export default {
    SaveCalendarEvent: {
        name: 'SaveCalendarEvent',
    },

    SaveCalendarDraft: {
        name: 'SaveCalendarDraft',
    },
};
